const NoticeType = {
    name: 'Name',
    priority: 'Priority',
    template_subject: 'Template subject',
    template_body: 'Template body',
    search: 'Search',
    noticeType: 'Notice Type',
    error_name: 'Enter name',
    error_priority: 'Enter priority',
    error_template_subject: 'Enter template subject',
    error_template_body: 'Enter template body',
    table_name: 'NAME',
    table_priority: 'PRIORITY',
    table_template_subject: 'TEMPLATE SUBJECT',
}

export default NoticeType;
